import _createForOfIteratorHelper from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { __rest } from 'tslib';
import { resize } from '../resize/index.es.js';
import { createScrollInfo } from './info.es.js';
import { createOnScrollHandler } from './on-scroll-handler.es.js';
var scrollListeners = new WeakMap();
var resizeListeners = new WeakMap();
var onScrollHandlers = new WeakMap();
var getEventTarget = function getEventTarget(element) {
  return element === document.documentElement ? window : element;
};
function scroll(onScroll) {
  var _a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _a$container = _a.container,
    container = _a$container === void 0 ? document.documentElement : _a$container,
    options = __rest(_a, ["container"]);
  var containerHandlers = onScrollHandlers.get(container);
  /**
   * Get the onScroll handlers for this container.
   * If one isn't found, create a new one.
   */
  if (!containerHandlers) {
    containerHandlers = new Set();
    onScrollHandlers.set(container, containerHandlers);
  }
  /**
   * Create a new onScroll handler for the provided callback.
   */
  var info = createScrollInfo();
  var containerHandler = createOnScrollHandler(container, onScroll, info, options);
  containerHandlers.add(containerHandler);
  /**
   * Check if there's a scroll event listener for this container.
   * If not, create one.
   */
  if (!scrollListeners.has(container)) {
    var _listener = function _listener() {
      var time = performance.now();
      var _iterator = _createForOfIteratorHelper(containerHandlers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var handler = _step.value;
          handler.measure();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(containerHandlers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _handler = _step2.value;
          _handler.update(time);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(containerHandlers),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _handler2 = _step3.value;
          _handler2.notify();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };
    scrollListeners.set(container, _listener);
    var target = getEventTarget(container);
    window.addEventListener("resize", _listener, {
      passive: true
    });
    if (container !== document.documentElement) {
      resizeListeners.set(container, resize(container, _listener));
    }
    target.addEventListener("scroll", _listener, {
      passive: true
    });
  }
  var listener = scrollListeners.get(container);
  var onLoadProcesss = requestAnimationFrame(listener);
  return function () {
    var _a;
    if (typeof onScroll !== "function") onScroll.stop();
    cancelAnimationFrame(onLoadProcesss);
    /**
     * Check if we even have any handlers for this container.
     */
    var containerHandlers = onScrollHandlers.get(container);
    if (!containerHandlers) return;
    containerHandlers["delete"](containerHandler);
    if (containerHandlers.size) return;
    /**
     * If no more handlers, remove the scroll listener too.
     */
    var listener = scrollListeners.get(container);
    scrollListeners["delete"](container);
    if (listener) {
      getEventTarget(container).removeEventListener("scroll", listener);
      (_a = resizeListeners.get(container)) === null || _a === void 0 ? void 0 : _a();
      window.removeEventListener("resize", listener);
    }
  };
}
export { scroll };